import React, { useState } from 'react';
import './App.css';

import project1Image from './images/project1.png';
import project2Image from './images/project2.png';
import project3Image from './images/project3.jpg';
import project4Image from './images/project4.jpg';
import project5Image from './images/project5.gif';
import project6Image from './images/project6.gif';
import gmailIcon from './images/gmail.png';
import linkedinIcon from './images/linkedin.png';
import githubIcon from './images/github.png';

function App() {
  const [isDarkMode, setIsDarkMode] = useState(true);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <div className={`App ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
      <header className="App-header">
        <div className="header-content">
          <h1>Arkadiusz Debert - Game Development Portfolio</h1>
        </div>
        <button className="theme-toggle" onClick={toggleTheme}>
          {isDarkMode ? 'Light' : 'Dark'}
        </button>
      </header>
      <section className="About-me">
        <h2>About Me!</h2>
        <p>
          Hello! I'm currently a Master's student at the University of Central Lancashire. 
          I'm a passionate game developer with experience in game engines such as Unreal Engine and programming languages like C++, 
          always looking to expand my knowledge and learn new things. My main interests are MOBAs and movement-based games. 
          The portfolio below covers some of my solo game projects (like VZN) and team projects (like Abyssal Uprising), 
          alongside other non-game-related work such as a Movie Database app.
        </p>
      </section>
      <section className="Portfolio">
        <h2>Portfolio</h2>
        <p>Here are some of my projects:</p>
        <ul>
          <li className="project-item">
            <img src={project1Image} alt="Project 1" className="project-image" />
            <div className="project-details">
              <h3 className="project-title">VZN</h3>
              <p>
                VZN is a movement-based/parkour project developed for a Master's solo project module, built in Unreal Engine 5 using C++. 
                Aiming to achieve great movement mechanics, 
                VZN's level design is focused on allowing the player to test all of the movement features. 
              </p>
              <p>
                Key Features:
                <ul className="project-features">
                  <li>Climbing - Climbing on walls, includes hopping up and down.</li>
                  <li>Vaulting - Jumping over an object.</li>
                  <li>Dash - Short dash ability, launching the player forward.</li>
                  <li>Camera Switch - Switch between first person and third person.</li>
                  <li>Sliding - Sliding to get under low gaps in the walls.</li>
                  <li>Launchpad - Provides the player with a jump boost.</li>
                  <li>Grapple Hook - Attach to a grapple point to swing across.</li>
                  <li>Moving Platforms - Platforms moving in a ping pong fashion between set points.</li>
                  <li>Inverse Kinematics & Motion Warping - Used for climbing and vaulting.</li>
                </ul>
              </p>
              <a href="https://www.youtube.com/watch?v=NSguLhWJ1vI&ab_channel=ArkadiuszDebert" target="_blank" rel="noopener noreferrer">YouTube Demonstration</a>
              <p>
              <a href="https://github.com/azDebert/Project1-VZN" target="_blank" rel="noopener noreferrer">GitHub Repository</a>
              </p>
            </div>
          </li>
          <li className="project-item">
            <img src={project2Image} alt="Project 2" className="project-image" />
            <div className="project-details">
              <h3 className="project-title">Abyssal Uprising</h3>
              <p>
                Abyssal Uprising was created as part of the Master's Team Project module in a team of three. 
                The game was made in Unreal Engine 5.3.2 using mainly C++. 
              </p>
              <p>
                The game is a Third Person, Open World, Looter Shooter where the player can arm themselves with many different guns, ranging from pistols to rifles.
                The lore rich planet is filled with a variety of different enemies that test the player's skill and abilities.
                It was designed in a way for the player to be able to explore freely with many camps and points of interests.
                The main goal of the game is to battle through the enemy encampments, unlock the boss fight and defeat the final boss to find out the truth about the planet.
                The goal can be achieved through collecting Guardian Souls from the enemy guardians and unlocking the Boss' cave.
              </p>
              <p>
                As a team we had to pitch and present the game idea by creating a pitch presentation and a game design document for the game.
                The game design document was used to keep track of progress.
                Abyssal Uprising was created within a six month timescale. The time was split into planning, designing and developing the game. 
                My main role included contributing to the overall project development, designing maps, and testing implemented features,
                 as well as assisting my teammates in various aspects of the game.
              </p>
              <a href="https://www.youtube.com/watch?v=cZl1L9TErXE&ab_channel=ArkadiuszDebert" target="_blank" rel="noopener noreferrer">YouTube Demonstration</a>
              <p>
              <a href="https://drive.google.com/drive/folders/1wgZMJc7qKKMjD-349hQ52dHqwxXnf415" target="_blank" rel="noopener noreferrer">Google Drive Link</a>
              <li>
                Contains: Executable, Game Design Document, Proposal Presentation.
              </li>
              </p>
            </div>
          </li>
          <li className="project-item">
            <img src={project3Image} alt="Project 3" className="project-image" />
            <div className="project-details">
              <h3 className="project-title">3D Platformer</h3>
              <p>
                3D Platformer is an engaging game developed in Unreal Engine 5 (UE5) using C++ and Blueprints in approximately 60-80 hours (about a week). 
                It features a level hub and three levels, including a tutorial level to test various mechanics. 
                Aiming to achieve a near finished game with a variety of challenges and exciting features.
              </p>
              <p>
                Features:
                <ul className="project-features">
                  <li>Double Jump - Extra jump while mid-air.</li>
                  <li>Dash - Short dash ability.</li>
                  <li>Wall Hang - Player can hang onto ledges to then jump up.</li>
                  <li>Launchpad - Provides the player with a jump boost.</li>
                  <li>Moving Platforms - Platforms moving in a ping pong fashion.</li>
                  <li>Falling Platforms - Collapse after being stepped on.</li>
                  <li>Low Gravity Platforms - Apply low gravity effect once stepped on.</li>
                  <li>Ice - Slippery surface that challenges the player's control.</li>
                  <li>Interactable Blocks - Display tips and hints interacted with.</li>
                  <li>Levers - Switch connected features on and off.</li>
                  <li>Fans - Push player upwards, allowing access to the higher platforms.</li>
                  <li>Checkpoint - Saves the player's progress, used for respawns.</li>
                  <li>Pickup Hearts - Half Heart, Full Heart, Gold Heart.</li>
                  <li>Pickup Coins - Bronze Coin, Silver Coin, Gold Coin.</li>
                  <li>Spikes - Damage the player upon contact.</li>
                  <li>Enemies - Two enemies that can be slayed upon hopping on them.</li>
                  <li>Boss - Can only be defeated using advanced movement controls and environment around them.</li>
                </ul>
              </p>
              <a href="https://www.youtube.com/watch?v=2maaWCkYQAU&ab_channel=ArkadiuszDebert" target="_blank" rel="noopener noreferrer">YouTube Demonstration</a>
              <p>
              <a href="https://github.com/azDebert/Project3-3DPlatformer" target="_blank" rel="noopener noreferrer">GitHub Repository</a>
              </p>
            </div>
          </li>
          <li className="project-item">
            <img src={project4Image} alt="Project 4" className="project-image" />
            <div className="project-details">
              <h3 className="project-title">Zyzz</h3>
              <p>
                Made in my second year of University as a part of a team assignment, using a Kanban approach to plan out the project. 
                With the use of Trello we were able to track and monitor all of our tasks and set appropriate deadlines.
                The game is a 3D platformer developed using Unreal Engine 4 using Blueprints and C++. 
                Zyzz features a wizard as the main character is able to shoot fireballs and cast an area of effect spell. 
                The wizard is able to do parkour through the use of double jumps and wall jumps which allows the player to navigate through the levels and pick up the collectibles.
                The game features four maps, the level hub, tutorial level, level one and two.
                Zyzz was one of the first projects where I worked in an organised team, and the main things I worked on were:
              </p>
              <p>
              <ul className="project-features">
                <li>Level design</li>
                <li>Character</li>
                <li>Character movement</li>
                <li>Collectibles</li>
                <li>Interactable objects</li>
              </ul> 
              </p> 
              <a href="https://www.youtube.com/watch?v=MxRFfEK2QEI&ab_channel=ArkadiuszDebert" target="_blank" rel="noopener noreferrer">YouTube Demonstration</a>
              <p>
              <a href="https://github.com/azDebert/Project4-Zyzz" target="_blank" rel="noopener noreferrer">GitHub Repository</a>
              </p>
            </div>
          </li>
          <li className="project-item">
            <img src={project5Image} alt="Project 5" className="project-image" />
            <div className="project-details">
              <h3 className="project-title">Post Processing</h3>
              <p>
                DirectX11 program featuring a variety of full screen post processing effects. The process of creating these filter effects was 
                done by rendering the scene to a temporary texture, applying effects with shaders and then displaying the final result. 
              </p>
              <p>
                List of effects:
                <ul className="project-features">
                  <li>Gradient</li>
                  <li>Blur</li>
                  <li>Underwater</li>
                  <li>Retro</li>
                  <li>Gaussian Blur</li>
                  <li>Bloom</li>
                </ul>
              </p>
              <a href="https://github.com/azDebert/Project5-PostProcessing" target="_blank" rel="noopener noreferrer">GitHub Repository</a>
            </div>
          </li>
          <li className="project-item">
            <img src={project6Image} alt="Project 6" className="project-image movie-db-image" />
            <div className="project-details">
              <h3 className="project-title">Movie Database App</h3>
              <p>
                A mobile application using Flutter and Dart. It uses the TMDB API to retrieve and display movie and TV show information. By utilising the API,
                the app is able to fetch the latest movie information, keeping it up to date. 
                The app consists of three rows which are: trending movies, top rated movies and currently airing TV shows. Making the navigation user-friendly due to its simplicity.
                The user is able to click on a movie or a TV show to view details on them as well as the rating.
              </p>
              <a href="https://github.com/azDebert/Project6-MovieApp" target="_blank" rel="noopener noreferrer">GitHub Repository</a>
            </div>
          </li>
        </ul>
      </section>
      <section className="Contact">
        <h2>Contact</h2>
        <div className="contact-row">
          <p>
            <a href="mailto:adebert20@gmail.com">
              <img src={gmailIcon} alt="Email" className="contact-icon" /> adebert20@gmail.com
            </a>
          </p>
          <p>
            <a href="https://www.linkedin.com/in/adebert20/" target="_blank" rel="noopener noreferrer">
              <img src={linkedinIcon} alt="LinkedIn" className="contact-icon" /> LinkedIn
            </a>
          </p>
          <p>
            <a href="https://github.com/azDebert" target="_blank" rel="noopener noreferrer">
              <img src={githubIcon} alt="GitHub" className="contact-icon" /> GitHub
            </a>
          </p>
        </div>
      </section>
    </div>
  );
}

export default App;